module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss-5e494162f003c94534b734ab54457ff1.jpg";